import { render, staticRenderFns } from "./InvoiceServiceViewItem.vue?vue&type=template&id=5d5d51a4&scoped=true&"
import script from "./InvoiceServiceViewItem.vue?vue&type=script&lang=js&"
export * from "./InvoiceServiceViewItem.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceServiceViewItem.vue?vue&type=style&index=0&id=5d5d51a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d51a4",
  null
  
)

export default component.exports